import { observable, action, makeAutoObservable, runInAction } from "mobx";
import { message, notification } from "antd";
import { persist } from 'mobx-persist';
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";

class MockElectionStore {

    @observable loading = false;
    @observable isSuccess = false;

    @observable perPage = 10;
    @observable hasMore = false;
    @observable page = 1;

    @observable senators = [];
    @observable congressmans = [];
    @observable governors = [];
    @observable viceGovernors = [];
    @observable sangguniangPanlalawigan = [];
    @observable mayors = [];
    @observable viceMayors = [];
    @observable sangguniangBayan = [];

    @observable isAlreadyVoted = false;

    constructor() {
        makeAutoObservable(this);
    }
    
    @action
    validateIfAlreadyVoted = async (values) => {
        
        this.loading = true;
        
        try {
            const response = await axios.post(`/mock_election/validate_if_already_voted.php`, values, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                this.isAlreadyVoted = true
            }

        } catch (error) {
            console.log(error.response.data);
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'User already voted',
                    description: error.response.data.message
                });
                message.error('User already voted');
            }
            runInAction(() => {
                this.isAlreadyVoted = false
            });
        } finally {
            runInAction(() => {
                if(this.isSuccess == true){
                    this.loading = true;
                }else{
                    this.loading = false;
                }
                
            });
        }
    }

    @action
    createVote = async (values) => {
        
        this.loading = true;
        
        try {
            const response = await axios.post(`/mock_election/create.php`, values, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                notification.success({
                    top: 120,
                    message: 'Good Job!',
                    description: 'Vote successfully recorded.'
                });

                Swal.fire({
                    title: "Good Job!",
                    icon: "success",
                    text: "Vote Recorded",
                    confirmButtonText: "Okay",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        //REDIRECT TO THE LIST OF
                        setTimeout(function() {
                            window.location.reload();
                        }, 500);
                    } 
                })
            }

        } catch (error) {
            console.log(error.response.data);
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'User Registration Error',
                    description: error.response.data.message
                });
                message.error('User Registration Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                if(this.isSuccess == true){
                    this.loading = true;
                }else{
                    this.loading = false;
                }
                
            });
        }
    }

    @action
    fetchCandidates = async () => {
        
        this.loading = true;
        
        try {
            const response = await axios.get(`/candidates/get_all.php`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            console.log()
            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        const data = response.data.data;

                        this.senators = data.senators;
                        this.congressmans = data.congressmans;
                        this.governors = data.governors;
                        this.viceGovernors = data.viceGovernors;
                        this.sangguniangPanlalawigan = data.sangguniangPanlalawigan;
                        this.mayors = data.mayors;
                        this.viceMayors = data.viceMayors;
                        this.sangguniangBayan = data.sangguniangBayan;
                    }
                });
            }
        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetching Events Error',
                    description: error.response.data.message
                });
                message.error('Fetching Events Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
        
    }
}

export default MockElectionStore;
